/**
 * AppProviders
 *
 * Combined context providers wrapper for the entire application.
 * Wraps all contexts in the correct order for proper dependency injection.
 *
 * GameDataProvider is outermost - provides static game data from backend
 * AuthProvider - handles authentication
 * InventoryProvider - manages user inventory (depends on Auth)
 * CareerProvider - manages career state (depends on Auth, Inventory)
 * TutorialProvider - manages first-time user tutorial (depends on Inventory)
 * GameProvider - manages active game state
 */

import React from 'react';
import { GameDataProvider } from './GameDataContext';
import { AuthProvider } from './AuthContext';
import { GameProvider } from './GameContext';
import { InventoryProvider } from './InventoryContext';
import { CareerProvider } from './CareerContext';
import { TutorialProvider } from './TutorialContext';

export const AppProviders = ({ children }) => {
  return (
    <GameDataProvider>
      <AuthProvider>
        <InventoryProvider>
          <CareerProvider>
            <TutorialProvider>
              <GameProvider>
                {children}
              </GameProvider>
            </TutorialProvider>
          </CareerProvider>
        </InventoryProvider>
      </AuthProvider>
    </GameDataProvider>
  );
};
